import { Component, ElementRef, forwardRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Regulation } from '../../../shared/models/regulation.model';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-statements',
  templateUrl: './statements.component.html',
  styleUrls: ['./statements.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => StatementsComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => StatementsComponent),
      multi: true,
    },
  ],
})
export class StatementsComponent implements ControlValueAccessor, OnInit {
  @ViewChildren('statement') sectionsElements!: QueryList<ElementRef>;

  @Input()
  public submitted: boolean;
  @Input()
  public statements: Regulation[];

  @Input()
  initialValue: number[] = [];

  @Input()
  padding: string;

  @Input()
  margin: string;

  touched = false;
  value: number[] = [];
  touchedRegulations: number[] = [];

  public toggled = false;

  public checkedAll = false;

  private _hideCheckAll = false;

  @Input()
  set hideCheckAll(value: boolean) {
    if (value) {
      this.toggled = true;
    }
    this._hideCheckAll = value;
  }

  get hideCheckAll() {
    return this._hideCheckAll;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange = (_: any) => {
  };
  private onTouched: () => void = () => {
  };

  public isChecked(value: number): boolean {
    if (this.value) {
      return this.value.includes(value);
    } else {
      return false;
    }
  }

  public isTouched(value: number): boolean {
    return this.submitted || this.touchedRegulations.includes(value);
  }

  public addToTouched(value: number): void {
    if (!this.isTouched(value)) {
      this.touchedRegulations.push(value);
    }
  }

  public toggleCheckbox(regulationId: number): void {
    const index = this.value.indexOf(regulationId);
    this.addToTouched(regulationId);
    if (index === -1) {
      this.value.push(regulationId);
    } else {
      this.value.splice(index, 1);
    }
    this.onChange(this.value);
    this.setCheckedAllValue();
  }

  private checkValue(regulationId: number) {
    const index = this.value.indexOf(regulationId);
    this.addToTouched(regulationId);
    if (index === -1) {
      this.value.push(regulationId);
    }
  }

  private unCheckValue(regulationId: number) {
    const index = this.value.indexOf(regulationId);
    if (index >= 0) {
      this.value.splice(index, 1);
    }
    this.checkedAll = false;
  }

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  markAsTouched(): void {
    this.touched = true;
    this.onTouched();
  }


  constructor() {
  }

  ngOnInit(): void {
    if (this.initialValue !== undefined) {
      this.value = this.initialValue;
    }
    this.setCheckedAllValue();
  }

  public toggle(value?: boolean): void {
    if (value !== null && value !== undefined) {
      this.toggled = value;
    } else {
      this.toggled = !this.toggled;
    }
  }

  public changeAll(): void {
    this.checkedAll = !this.checkedAll;
    if (this.checkedAll) {
      this.statements.forEach(value1 => {
        this.checkValue(value1.id);
      });
      this.toggled = true;
      this.setCheckedAllValue();
    } else {
      this.statements.forEach(value1 => {
        this.unCheckValue(value1.id);
      });
    }
    this.onChange(this.value);
  }

  validate() {
    return this.isValid() ? null : { required: true };
  }


  private isValid() {
    const requiredIds = this.statements.filter(statement => statement.required).map(statement => statement.id);
    return (this.value !== null) && (requiredIds.every(requiredId => this.value.includes(requiredId)));
  }

  private setCheckedAllValue() {
    if (this.value !== null && this.statements.length === this.value.length) {
      this.checkedAll = true;
    } else {
      this.checkedAll = false;
    }
  }

  public markAsTouchedAfterSubmit() {
    const requiredIds = this.statements.filter(statement => statement.required).map(statement => statement.id);
    requiredIds.every(requiredId => this.value.includes(requiredId));
    this.touchedRegulations.push(...requiredIds);
  }

  public get componentStyle() {
    if (this.padding) {
      if (this.margin) {
        return {
          margin: this.margin,
          padding: this.padding,
        };
      } else {
        return {
          'margin-bottom': '8px',
          padding: this.padding,
        };
      }
    } else {
      if (this.margin) {
        return {
          margin: this.margin,
        };
      } else {
        return {
          'margin-bottom': '8px',
        };
      }
    }
  }

  public onShowEvent(index: any) {
    const elementArray = this.sectionsElements.toArray();
    const targetElement = elementArray[index];

    if (targetElement) {
      targetElement.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }
}
